"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoAccountYet = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var mona_1 = require("@artegeie/design-system/mona");
var AskQuestion_1 = __importDefault(require("../AskQuestion/AskQuestion"));
var form_1 = require("../../form");
var style_1 = require("../../style");
var Col_1 = require("../../layout/Col");
var useFormattedMessages_1 = __importDefault(require("../../../context/useFormattedMessages"));
var NoAccountYet = function (_a) {
    var onRegister = _a.onRegister;
    var messages = (0, useFormattedMessages_1.default)('form.auth.noAccountYet');
    return (0, jsx_runtime_1.jsxs)(Col_1.Col, __assign({ alignItems: 'center' }, { children: [(0, jsx_runtime_1.jsx)(style_1.Spacer, __assign({ spacer: mona_1.sSpacer }, { children: (0, jsx_runtime_1.jsx)(style_1.Typography, { children: messages.noAccount }, void 0) }), void 0), (0, jsx_runtime_1.jsx)(form_1.SecondaryButton, { value: messages.freeRegister, onClick: onRegister }, void 0), (0, jsx_runtime_1.jsx)(style_1.Spacer, __assign({ spacer: mona_1.sSpacer, direction: 'top' }, { children: (0, jsx_runtime_1.jsx)(AskQuestion_1.default, {}, void 0) }), void 0)] }), void 0);
};
exports.NoAccountYet = NoAccountYet;
exports.default = exports.NoAccountYet;
